import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  linkTo?: string;
  linkLabel?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  linkTo,
  linkLabel = "查看全部",
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div
      className={`mb-8 flex flex-col gap-4 md:flex-row md:items-end ${
        isCenter ? "md:flex-col md:items-center md:text-center" : "md:justify-between"
      }`}
    >
      <div className={isCenter ? "md:text-center" : ""}>
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-2 text-xs font-medium tracking-[0.25em] text-primary-600">
            <span className="h-px w-6 bg-primary-500" />
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {description && (
          <p className={`mt-2 text-sm text-foreground-600 ${isCenter ? "md:mx-auto" : ""} max-w-2xl`}>
            {description}
          </p>
        )}
      </div>
      {linkTo && !isCenter && (
        <Link
          to={linkTo}
          className="inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer"
        >
          {linkLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}